module.exports = __webpack_public_path__ + "media/images/favicons/ms-icon-70x70-0f060c58ff5ebfe15172f9b1dfbe9e8a.png";